export const SET_USER_PLANT = 'SET_USER_PLANT';
export const SET_USER_DETAIL = 'SET_USER_DETAIL';
export const SET_PLANT_HOST = 'SET_PLANT_HOST';
export const DRAW_RECORD_DATA = 'DRAW_RECORD_DATA';
